/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:0c832f0e-9f1b-466d-8545-2b735f93ee02",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_1zPkoziPT",
    "aws_user_pools_web_client_id": "5sf249403hqbloeqgsvl12tfkm",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "api604c21a1",
            "endpoint": "https://z51wrztrwe.execute-api.us-east-1.amazonaws.com/primectl",
            "region": "us-east-1"
        },
        {
            "name": "transcripts",
            "endpoint": "https://9bshfubvrb.execute-api.us-east-1.amazonaws.com/primectl",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "lc-csvuploadstore-664427069985-primectl",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "contactsStore-primectl",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
